import { useMemo } from "react";
import moment from "moment";
import { _DATE_FORMAT } from "../../constants";
import { DateFormatter, TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import { Delete, Article } from "@mui/icons-material";
import { is } from "../../function";

export const ImportErrorColumns = (
  setImportError,
  setShowDetailErros,
  setShowConfirmDeleteImportError,
) => {
  return useMemo(
    () => [
      {
        accessorKey: "fileName",
        header: "File name",
        enableSorting: true,
        sortingFn: "alphanumeric",
        muiTableHeadCellProps: { sx: { flex: "1 1 0%" } },
        muiTableBodyCellProps: { sx: { flex: "1 1 0%" } },
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original?.fileName,
          });
        },
      },
      {
        accessorKey: "site",
        header: "Site",
        enableSorting: true,
        sortingFn: "alphanumeric",
        muiTableHeadCellProps: { sx: { flex: "1 1 0%" } },
        muiTableBodyCellProps: { sx: { flex: "1 1 0%" } },
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original?.site?.name,
          });
        },
      },
      {
        accessorKey: "period",
        header: "Period",
        enableSorting: true,
        sortingFn: "alphanumeric",
        muiTableHeadCellProps: { sx: { flex: "1 1 0%" } },
        muiTableBodyCellProps: { sx: { flex: "1 1 0%" } },
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original?.period,
          });
        },
      },
      {
        accessorKey: "importDate",
        header: "Import date",
        enableSorting: true,
        sortingFn: "datetime",
        muiTableHeadCellProps: { sx: { flex: "1 1 0%" } },
        muiTableBodyCellProps: { sx: { flex: "1 1 0%" } },
        Cell: ({ row }) => {
          return (
            <DateFormatter
              momentDate={moment(row.original?.importDate)}
              format={_DATE_FORMAT["date_and_time"]}
            />
          );
        },
      },
      {
        accessorKey: "action",
        header: "Action",
        muiTableHeadCellProps: { sx: { flex: "1 1 0%" } },
        muiTableBodyCellProps: { sx: { flex: "1 1 0%" } },
        enableSorting: false,
        Cell: ({ row }) => {
          const ligne = row.original;
          const hasErrors = is(ligne.errorDetails);

          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setImportError(ligne);
                  setShowConfirmDeleteImportError(true);
                }}
              >
                <Delete />
              </IconButton>
              {hasErrors && (
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setImportError(ligne);
                    setShowDetailErros(true);
                  }}
                >
                  <Article />
                </IconButton>
              )}
            </>
          );
        },
      },
    ],
    [setImportError, setShowDetailErros, setShowConfirmDeleteImportError],
  );
};
